import EmailsDirToolBar from '../EmailsDirToolBar';
import EmailsTable from '../EmailsTable';
import EmailEntryFormik from '../EmailEntryFormik';

const TabOthers = () => (
    <>
        <EmailEntryFormik />
        <EmailsDirToolBar tab="others" />
        <EmailsTable others />
    </>
);

export default TabOthers;
